import { ModalMode } from '../crew-scheduling-v3/modals/interfaces';
import MODAL_MODE from '../../../pages/data/common/constants';
import actions from './actions';
import {
  Qualification,
  QualificationUserRelation,
} from '../../../pages/data/organization/tracked-items/types';

export interface QualificationModalInitialState {
  qualifications: Qualification[];
  archivedQualifications: Qualification[];
  qualificationUserRelations: QualificationUserRelation[];
  modalMode: ModalMode;
  filterName: string;
  filterQualifications: Qualification[];
  qualificationStructure: Record<string, any[]>;
  trackedItemsByQual: Record<string, any[]>;
  certGroupsByQual: Record<string, any[]>;
  expandedQualificationId: string;
}

const initialState: QualificationModalInitialState = {
  modalMode: { open: false, mode: MODAL_MODE.create },
  qualifications: [],
  archivedQualifications: [],
  qualificationUserRelations: [],
  filterName: null,
  filterQualifications: [],
  qualificationStructure: {},
  trackedItemsByQual: {},
  certGroupsByQual: {},
  expandedQualificationId: null,
};

export default function reducers(state: QualificationModalInitialState = initialState, action) {
  switch (action.type) {
    case actions.OPEN_MODAL:
      return { ...state, modalMode: { open: true, mode: action.payload.mode } };
    case actions.CLOSE_MODAL:
      return { ...state, modalMode: { open: false, mode: MODAL_MODE.create } };
    case actions.SET_QUALIFICATIONS:
    case actions.SET_FILTER_QUALIFICATIONS:
    case actions.SET_QUALIFICATION_USER_RELATIONS:
    case actions.SET_FILTER_NAME:
    case actions.SET_EXPANDED_QUALIFICATION_ID:
    case actions.SET_QUALIFICATIONS_STRUCTURE:
    case actions.SET_TRACKED_ITEMS_BY_QUAL:
    case actions.SET_CERT_GROUPS_BY_QUAL:
    case actions.SET_ARCHIVED_QUALIFICATIONS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
